// import { api } from "boot/axios";

// export const getGenerator = async ({commit}, form) => {
//   try {
//     const resp = await api.post('/sunat/generator/filter/', form)
//     commit('setTableGenerator', resp.data)
//     return Promise.resolve('vuamos :v')
//   } catch (error) {
//     console.log(error)
//     return Promise.reject('no pasa :V')
//   }
// }
